import { useParams } from 'react-router';

import { useScenarioDetailsContext } from '@app-velocity/modules/scenarios';

import { useCreateScenarioHeatMap } from '../../hooks/useCreateScenarioHeatMap';
import { ClickMapActions } from '../ClickMapActions/ClickMapActions';

export const RenderClickMapButton = () => {
  const { scenario } = useScenarioDetailsContext();
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const { generateHeatMap, clearHeatMap } = useCreateScenarioHeatMap(
    scenario.id!,
    workspaceId || '',
    scenario.prototypePages || [],
    scenario.prototypePartials || []
  );

  return <ClickMapActions generate={generateHeatMap} clear={clearHeatMap} />;
};
